import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FeedbackManagerRenderer from './FeedbackManagerRenderer';
import SurveyManagerRenderer from './SurveyManagerRenderer';

class DeatilRenderer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.node.expanded,
    };
    this.handleRowGroupOpened = this.handleRowGroupOpened.bind(this);
  }

  componentWillMount() {
    this.props.node.setRowHeight(30);
  }
  componentDidMount() {
    this.props.api.addEventListener('rowGroupOpened', this.handleRowGroupOpened);
  }
  componentWillUnmount() {
    this.props.api.removeEventListener('rowGroupOpened', this.handleRowGroupOpened);
  }

  handleRowGroupOpened() {
    const { node } = this.props;
    const { expanded } = node;
    this.setState({ expanded });
  }

  render() {
    const { data, context: { detailModes } } = this.props;
    const { expanded } = this.state;
    const mode = detailModes[data.opportunity_id];
    if (mode === 'feedbacks') {
      return (
        <FeedbackManagerRenderer {...this.props} expanded={expanded} />
      );
    } else if (mode === 'surveys') {
      return (
        <SurveyManagerRenderer {...this.props} expanded={expanded} />
      );
    }
    return null;
  }
}

DeatilRenderer.propTypes = {
  data: PropTypes.shape({
    opportunity_id: PropTypes.string,
  }).isRequired,
  node: PropTypes.shape({
    setRowHeight: PropTypes.func,
    expanded: PropTypes.bool,
  }).isRequired,
  api: PropTypes.shape({
    onRowHeightChanged: PropTypes.func,
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
  }).isRequired,
  context: PropTypes.shape({
    detailModes: PropTypes.shape({}).isRequired,
  }).isRequired,
};
DeatilRenderer.defaultProps = {
};

export default DeatilRenderer;
